/* eslint-disable no-unused-vars */
import axios from 'axios';
import api from '@src/api';

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    workoutDetails: null,
    programDay: null,
  };
}

export const getters = {};

export const mutations = {
  setWorkoutDetails(state, value) {
    state.workoutDetails = value;
  },
  setProgramDay(state, value) {
    state.programDay = value;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getProgramDay(ctx, payload) {
    if (
      payload.programDay_id !== undefined &&
      payload.org_id !== undefined &&
      payload.trainer_id !== undefined &&
      payload.user_id !== undefined
    ) {
      const url = api.URL_PROGRAM_DAY_DETAILS.replace(':programDayID', payload.programDay_id)
        .replace(':orgID', payload.org_id)
        .replace(':trainerID', payload.trainer_id)
        .replace(':userID', payload.user_id);

      return axios
        .get(url)
        .then((res) => {
          if (res && res.data && res.data.success) {
            ctx.commit('setProgramDay', res.data.programDay);
            if (res.data.programDay.workouts && res.data.programDay.workouts.length > 0)
              ctx.commit('setWorkoutDetails', res.data.programDay.workouts[0]);
            return res.data.programDay;
          }
        })
        .catch((err) => {
          console.warn(err);
          throw err;
        });
    } else {
      console.error(
        'payload must contain the following properties to be a valid replacement [ programDay_id, org_id, trainer_id, user_id ]',
        payload
      );
    }
  },
};
